import {
  ModalContent,
  ModalHeader,
  ModalRoot,
  ModalTitle,
} from '@synoptic/ui-kit/modal/modal.js';
import { PropsWithChildren } from 'react';

export const ManageListModal = ({
  children,
  isOpen,
  onOpenChange,
  title,
}: PropsWithChildren<{
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  title: string;
}>) => {
  return (
    <ModalRoot open={isOpen} onOpenChange={onOpenChange}>
      <ModalContent>
        <ModalHeader>
          <ModalTitle>{title}</ModalTitle>
        </ModalHeader>
        <div>{children}</div>
      </ModalContent>
    </ModalRoot>
  );
};
